export default __webpack_public_path__ + "static/spotify-podcasts-f1757461da15831f490f6b6a12ac2790.svg";